<template>
    <div class="product-facts">
        <video-player :video-id="video" :thumb="videoThumb" />
        <div class="facts-box">
            <h3>Product Facts</h3>
            <ul>
                <li
                    v-for="(fact, index) in facts"
                    :key="index"
                    ref="facts"
                    style="opacity: 0"
                >
                    {{ fact }}
                </li>
            </ul>
            <img v-if="award" :src="award" alt="Award" class="award" />
        </div>
    </div>
</template>

<script>
import { gsap, Power4 } from 'gsap';
import VideoPlayer from './video-player';

export default {
    props: ['video', 'videoThumb', 'facts', 'award', 'onStage'],
    components: { VideoPlayer },
    mounted() {
        this.transitionIn();
    },
    methods: {
        transitionIn() {
            for (let index = 0; index < this.$refs.facts.length; index++) {
                const $el = this.$refs.facts[index];
                gsap.fromTo(
                    $el,
                    { opacity: 0, x: 50 },
                    {
                        delay: index * 0.25,
                        opacity: 1,
                        x: 0,
                        ease: Power4.easeOut
                    }
                );
            }
        }
    },
    watch: {
        facts() {
            this.transitionIn();
        },
        onStage(val) {
            if (val) {
                this.transitionIn();
            } else {
                for (let index = 0; index < this.$refs.facts.length; index++) {
                    const $el = this.$refs.facts[index];
                    gsap.to($el, { opacity: 0 });
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/sass/_globals/mixins';

.product-facts {
    margin-top: 1em;
    margin-right: 1.5em;
    margin-left: 2.5em;

    @include at-least($tlp) {
        position: absolute;
    }

    @include until($tlp) {
        margin-right: 1.2em;
        margin-left: 1.2em;
    }

    @include at-least($d) {
        margin-right: 6em;
        margin-left: 2.5em;
        position: relative;
    }

    .facts-box {
        h3 {
            background-color: #959595;
            width: 100%;
            padding: 0.5em 1em 0.5em 1em;
            color: #ffffff;
            font-size: 1.125em;
            font-weight: 600;
        }

        ul {
            background-color: rgba(255, 255, 255, 0.8);
            list-style: disc;
            padding: 1em 2em;

            li {
                margin-bottom: 0.75em;
                font-size: 0.75em;
                line-height: 1.14;
                color: #959595;
                font-family: 'Montserrat', sans-serif;
            }
        }

        .award {
            max-width: 100px;
            margin-top: 1em;
            margin-left: auto;
            margin-right: auto;
        }
    }
}
</style>
